/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { FetchItOutput } from "./fetchIt";

export function fetchItThen(response: Response): FetchItOutput {
  if (response.status < 200) {
    return { tag: "informational" as const, response };
  } else if (response.status < 300) {
    return { tag: "successful" as const, response };
  } else if (response.status < 400) {
    return { tag: "redirection" as const, response };
  } else if (response.status === 404) {
    return { tag: "data-error" as const, response };
  } else if (response.status < 500) {
    return { tag: "client-error" as const, response };
  } else {
    return { tag: "server-error" as const, response };
  }
}
